import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsComponent } from './components/documents/documents.component';
import { DocumentsRoutingModule } from './document-routing.module';
import { RouterModule } from '@angular/router';

import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { AngularMaterialModule } from '@cradua/material';

import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'libs/shared/src/lib/shared.module';
import { SpinnersModule } from './../../../spinners/src/lib/spinners.module';
import { StoreModule } from '@ngrx/store';
import { DocumentoperationsComponent } from './components/documents/documentoperations/documentoperations.component';
import { NgxDocViewerModule } from './components/documents/document-viewer/document-viewer/document-viewer.module';
import { AngularImageViewerModule } from 'angular-x-image-viewer';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AngularMaterialModule,
    EpimsDashboardNavModule,
    HttpClientModule,
    SpinnersModule,
    SharedModule,
    ReactiveFormsModule,

    FormsModule,
    DocumentsRoutingModule,
    NgxDocViewerModule,
    AngularImageViewerModule,
  ],
  declarations: [DocumentsComponent, DocumentoperationsComponent],
  entryComponents: [],
  exports: [DocumentsComponent, DocumentoperationsComponent],
})
export class DocumentoperationsModule {}
